import axios from "../axios/axios";
import { apiSetAlert } from "./appApi";
import { errorDispatcher, getOptionsQuery } from "helpers";
import { appSetLoading, appSetSendingRequest, appSetAlert } from "../store/actions/appAction";
import { setManufacturingFormData } from "../helpers/FormDataCreator";
import { setManufactureFormulas } from "../store/actions/manufactureFormulaAction";
import { selectTableItems } from "store/actions";
import { setTableData } from "store/actions/dataTableAction";

export const apiGetManufactureFormulas =
  ({ token }) =>
  (dispatch, getState) => {
    dispatch(appSetLoading());
    axios
      .get(`/manufacture/formulas/list`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        dispatch(setManufactureFormulas(response.data.productionFormulas));
        dispatch(appSetLoading(false));
      })
      .catch((error) => {
        errorDispatcher(error, dispatch);
      });
  };

export const apiGetManufactureFormula = (id, token, callback) => (dispatch, getState) => {
  dispatch(appSetLoading());
  axios
    .get(`/manufacture/formulas/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((res) => {
      dispatch(appSetLoading(false));
      callback(res.data.productionFormula);
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiSaveManufactureFormula = (form, token, navigate, cb) => (dispatch, getState) => {
  const formData = setManufacturingFormData(form);

  dispatch(appSetSendingRequest(true));
  axios
    .post(`/manufacture/formulas`, formData, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(appSetAlert(response.data.message, "success"));
      if (cb && typeof cb === "function") cb();
      navigate("/manufacture/formulas");
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
      if (cb && typeof cb === "function") cb();
    });
};

export const apiUpdateManufactureFormula =
  (manufacturingId, form, token, navigate, cb) => (dispatch, getState) => {
    const formData = setManufacturingFormData(form);

    dispatch(appSetSendingRequest(true));
    axios
      .put(`/manufacture/formulas/${manufacturingId}`, formData, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        dispatch(apiSetAlert(response.data.message, "success", false));
        if (cb && typeof cb === "function") cb();
        navigate("/manufacture/formulas");
      })
      .catch((error) => {
        errorDispatcher(error, dispatch);
        if (cb && typeof cb === "function") cb();
      });
  };

export const apiManufactureFormulas =
  ({ pagination, token, key, sort, search }) =>
  (dispatch, getState) => {
    // let personType = key;
    let url = "/manufacture/formulas/list";
    let options = getOptionsQuery(pagination, search, sort);

    // if (personType) {
    //   options.productionType = typeof personType === "string" ? personType : "all";
    // }

    dispatch(appSetLoading());
    axios
      .post(url, options, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        if (pagination && !pagination?.notTable) {
          dispatch(setTableData(response.data?.productionFormulas, response.data.paginate));
        }
        dispatch(appSetLoading(false));
      })
      .catch((error) => {
        errorDispatcher(error, dispatch);
      });
  };

export const apiManufactureFormulasChangeStatus = (selectedIds, token, callback) => (dispatch, getState) => {
  const productionId = selectedIds;
  dispatch(appSetLoading());
  dispatch(appSetSendingRequest());
  axios
    .post(
      `/manufacture/formulas/changeStatus`,
      {
        productionId,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
    .then((response) => {
      dispatch(apiSetAlert(response.data.message, "success"));
      if (callback) callback();
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiDeleteManufactureFormulas = (selectedIds, token, tab, callback) => (dispatch, getState) => {
  const productionIds = selectedIds;
  dispatch(appSetLoading());
  dispatch(appSetSendingRequest());
  axios
    .delete(`/manufacture/formulas/multiple/delete`, {
      headers: { Authorization: `Bearer ${token}` },
      data: { productionIds },
    })
    .then((response) => {
      dispatch(selectTableItems([]));
      dispatch(apiSetAlert(response.data.message, "success"));
      if (callback) callback();
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};
